import { Link } from 'react-router-dom';

// dark=true  → white/transparent style (for dark navbar backgrounds)
// dark=false → solid blue style (for light navbar backgrounds)
export default function SignInButton({ dark = true, onClick, style }) {
  const bg     = dark ? 'rgba(255,255,255,0.18)' : '#479EC3';
  const bgHov  = dark ? 'rgba(255,255,255,0.28)' : '#3B88A9';
  const border = dark ? '1.5px solid rgba(255,255,255,0.4)' : '1.5px solid transparent';

  return (
    <Link to="/auth" onClick={onClick}
      style={{
        fontSize: 14, fontWeight: 600, padding: '9px 20px', borderRadius: 9,
        background: bg, border, color: '#fff', textDecoration: 'none',
        transition: 'background .2s',
        ...style,
      }}
      onMouseEnter={e => { e.currentTarget.style.background = bgHov; }}
      onMouseLeave={e => { e.currentTarget.style.background = bg; }}
    >Sign In</Link>
  );
}
